import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    //  Tags
    getAllTags: (
      idList,
      onlyEnabled,
      onlyUsed,
      pageSize,
      pageNumber,
      orderBy,
      orderDescending
    ) =>
      `${baseURL}/api/tags?${encodeParams({
        idList,
        onlyEnabled,
        onlyUsed,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending
      })}`,

    getTag: (idTag) => `${baseURL}/api/tags/${idTag}`,

    addNewTag: () => `${baseURL}/api/tags`,

    //  Lists
    getList: (idList) => `${baseURL}/api/list/${encodeURIComponent(idList)}`,

    setWelcomeMessage: (idList) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/welcome/toggle`,

    getEntitiesUsingFilter: (idFilter) =>
      `${baseURL}/api/filter/${encodeURIComponent(idFilter)}/entities`,

    getListOfNlList: (force, pageSize, pageNumber, orderBy, orderDescending) =>
      `${baseURL}/api/lists?${encodeParams({
        force,
        pageSize,
        pageNumber,
        orderBy,
        orderDescending
      })}`,

    getUserVisibleLists: (idUser, pageNumber, pageSize) =>
      `${baseURL}/api/user/${encodeURIComponent(idUser)}/lists?${encodeParams({
        pageNumber,
        pageSize
      })}`,
    getTrackingInfoCustomParams: (idList) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}`,

    initMandatorySenderWithAnagraphicData: (idList) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/mandatorysender/init`,

    getMandatorySender: (idList) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/mandatorysender`,

    getUserLists: () => `${baseURL}/api/lists`,
    getStatusOfWelcomeMessage: (idList) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/welcome`
  }
})(process.env.BELIST_URL)

export const beListGetList = (idList) => {
  const url = endpoints.getList(idList)

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListSetWelcomeMessage = (idList, status) => {
  const url = endpoints.setWelcomeMessage(idList)

  return apiWrapper({
    method: 'put',
    url,
    data: JSON.stringify({ WelcomeMsgEnabled: status })
  }).then(extractApiData)
}

/**
 * @description Get a list of detailed lists
 * @param {Object} params
 * @param {boolean} params.force filtering flag, if present show only list linked to a specific UserId
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {string} params.orderBy Order by specified field
 * @param {string} params.orderDescending Order descending
 *
 *
 */
export const beListGetListOfNlList = (
  { force, pageSize, pageNumber, orderBy, orderDescending } = {
    force: true,
    pageSize: 0,
    pageNumber: 1
  }
) => {
  const url = endpoints.getListOfNlList(
    force,
    pageSize,
    pageNumber,
    orderBy,
    orderDescending
  )

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListApiGetAllTags = (
  idList,
  onlyEnabled = false,
  onlyUsed = false,
  pageSize = 0,
  pageNumber = 1,
  orderBy = 'Id',
  orderDescending = true
) => {
  const url = endpoints.getAllTags(
    idList,
    onlyEnabled,
    onlyUsed,
    pageSize,
    pageNumber,
    orderBy,
    orderDescending
  )

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListAddNewTag = (pIdList, pTagName) => {
  const url = endpoints.addNewTag()
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({ idlist: pIdList, name: pTagName, enabled: true })
  }).then(extractApiData)
}

export const beListGetUserVisibleLists = (
  idUser,
  pageNumber = 1,
  pageSize = 0
) => {
  const url = endpoints.getUserVisibleLists(idUser, pageNumber, pageSize)

  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListGetTrackingInfoCustomParams = (idList) => {
  const url = endpoints.getTrackingInfoCustomParams(idList)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListInitMandatorySenderWithAnagraphicData = (idList) => {
  const url = endpoints.initMandatorySenderWithAnagraphicData(idList)
  return apiWrapper({
    method: 'post',
    url
  }).then(extractApiData)
}

export const beListGetMandatorySender = (idList) => {
  const url = endpoints.getMandatorySender(idList)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListGetUserLists = () => {
  const url = endpoints.getUserLists()
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beListGetStatusOfWelcomeMessage = (idList) => {
  const url = endpoints.getStatusOfWelcomeMessage(idList)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}
